import { render, staticRenderFns } from "./blog-1.vue?vue&type=template&id=58fccd84&scoped=true"
import script from "./blog-1.vue?vue&type=script&lang=js"
export * from "./blog-1.vue?vue&type=script&lang=js"
import style0 from "./blog-1.vue?vue&type=style&index=0&id=58fccd84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fccd84",
  null
  
)

export default component.exports